import { plainToClass } from 'class-transformer';
import * as convertKeys from 'convert-keys';

import { Campaign } from '@/models/campaign';
import { LandingPage } from '@/models/landing_page';
import { debugLog } from '@/utils/debug';

import campaignJson from './campaign.json';
import landingPageJson from './landing_page.json';

export function loadCampaignJson() {
  return plainToClass(Campaign, convertKeys.toCamel<unknown>(campaignJson));
}

export function loadLandingPageJson() {
  const landingPage = plainToClass(LandingPage, convertKeys.toCamel<unknown>(landingPageJson));
  debugLog({ landingPage });

  return landingPage;
}

export const campaign = loadCampaignJson();
